import React from "react";
import { FormControl, InputLabel, Select } from "@mui/material";

// El desplegable de filial de los reportes.
//
// Las filiales que ofrece son las que el usuario puede ver: la suya si tiene
// una asignada, todas si no. Lo arma useFiltroFilial.
// bloqueado: el usuario tiene una filial asignada. El control muestra esa
// y no se puede cambiar. Sin filial asignada se ofrecen todas.
const FiltroFilial = ({ filiales, idFilial, onChange, bloqueado = false }) => (
    <FormControl fullWidth size="small" disabled={bloqueado}>
        <InputLabel htmlFor="input-filialreporte" shrink>Filial</InputLabel>
        <Select
            native
            label="Filial"
            value={idFilial || 0}
            onChange={(event) => onChange(parseInt(event.target.value, 10) || 0)}
            inputProps={{
                name: "idFilial",
                id: "input-filialreporte",
            }}
        >
            {!bloqueado && <option value={0}>Todas</option>}
            {filiales.map((filial) => (
                <option key={filial.id} value={filial.id}>
                    {filial.descripcion}
                </option>
            ))}
        </Select>
    </FormControl>
);

export default FiltroFilial;
